import { Outlet } from "react-router";
import LogoHeader from "@/components/logo-header/logo-header";

export default function InitPasswordLayout() {
  return (
    <div style={{ paddingTop: "5rem" }}>
      <LogoHeader />
      <Outlet />
    </div>
  );
}
